import React, { useState } from 'react';
import Agendamento from './sub-tabs/agendamento';
import Paciente from './sub-tabs/paciente';
import Gerais from './sub-tabs/gerais';

const subMenus = [
  { title: 'Agendamento', key: 'agendamento', component: Agendamento },
  { title: 'Paciente', key: 'paciente', component: Paciente },
  { title: 'Gerais', key: 'gerais', component: Gerais },
];

export const Sistema = ({ venda, configuracaoUnidade, onChange }) => {
  const [selected, setSelected] = useState(subMenus[0].key);

  const ActiveComponent = subMenus.find((item) => item.key === selected)?.component;

  return (
    <div style={styles.container}>
      <div style={styles.subMenu}>
        {subMenus.map((item) => {
          const isActive = selected === item.key;
          return (
            <div
              key={item.key}
              style={{
                ...styles.subMenuItem,
                ...(isActive ? styles.subMenuItemActive : {}),
              }}
              onClick={() => setSelected(item.key)}
            >
              {item.title}
            </div>
          );
        })}
      </div>
      <div style={styles.content}>
        {ActiveComponent && (
          <ActiveComponent
            venda={venda}
            configuracaoUnidade={configuracaoUnidade}
            onChange={onChange}
          />
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'grid',
    gridTemplateColumns: '200px 1fr',
    minHeight: '400px',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  subMenu: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f0f0f0',
    borderRight: '1px solid rgba(0, 0, 0, 0.1)',
    paddingTop: '16px',
  },
  subMenuItem: {
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 16px',
    cursor: 'pointer',
    color: '#505050',
    fontWeight: '400',
    backgroundColor: 'transparent',
    borderLeft: '3px solid transparent',
  },
  subMenuItemActive: {
    color: '#26ACA9',
    fontWeight: '600',
    backgroundColor: '#fff',
    borderLeft: '3px solid #26ACA9',
  },
  content: {
    padding: '16px',
    overflow: 'auto',
  },
};
